<div class="home-container">
  <div class="banner">
    <div class="banner-details">
      <div class="banner-details-margin">
        <h2>{{'heroMessage' | translate}}</h2>
        <button mat-raised-button class="simple-button pulse-element" (click)="redirectToGallery()">
          {{'heroButtonMessage' | translate}}
        </button>
      </div>
    </div>
  </div>

  <div class="text-container lazy-load hidden center-margin categories-container" #lazyElement>
    <h1>
      {{'exploreCategories' | translate}}
    </h1>
    <p>
      {{'exploreCategoriesDescription' | translate}}
    </p>

    <div class="categories">
      <div class="cat1" (click)="goToCategory('1')">
        <p>{{'galleryCanvasPaintings' | translate}}</p>
        <img alt="categorie pictura - panza" src="../../assets/other/categories/panza.jpg">
      </div>
      <div class="cat2" (click)="goToCategory('2')">
        <p>{{'galleryWallPaintings' | translate}}</p>
        <img alt="categorie pictura - perete" src="../../assets/other/categories/erete.jpg">
      </div>
      <div class="cat3" (click)="goToCategory('3')">
        <p>{{'namePicture51' | translate}}</p>
        <img alt="categorie pictura - martisoare" src="../../assets/other/categories/martisoare.jpg">
      </div>
      <div class="cat4" (click)="goToCategory('4')">
        <p>{{'gallerySpecialGifts' | translate}}</p>
        <img alt="categorie pictura - cadou" src="../../assets/other/categories/cadou.jpg">
      </div>
      <div class="cat5" (click)="goToCategory('5')">
        <p>{{'galleryChristmas' | translate}}</p>
        <img alt="categorie pictura - craciun" src="../../assets/other/categories/craciun.jpg">
      </div>
    </div>

    <div class="waves-divider">
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" class="shape-fill"></path>
        <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" class="shape-fill"></path>
        <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" class="shape-fill"></path>
      </svg>
    </div>

  </div>


  <div class="text-container lazy-load hidden" #lazyElement style="width: 100%">

    <div class="center-margin" style="width: 94%">
      <div class="counters first" style="padding-top: 0">
        <div class="art-objects">
          <div class="number">45+</div>
          <div class="description">{{'happyClients' | translate}}</div>
        </div>
        <div class="users">
          <div class="number">10+</div>
          <div class="description">{{'earsOfExperience' | translate}}</div>
        </div>
        <div class="artists">
          <div class="number">5</div>
          <div class="description">{{'nrOfExhibitions' | translate}}</div>
        </div>
      </div>
      <h1>
        {{'latestPainting' | translate}}
      </h1>
      <p>
        {{'latestDescription' | translate}}
      </p>
    </div>

    <div class="latest-projects">
      <div class="latest-project-img-container" (click)="goToPaintingDetails('1', '130')">
        <img src="../assets/gallery/130.jpg" alt="picturi favorite">
        <button mat-raised-button class="transparent-button">{{'seeDetails' | translate}}</button>
      </div>
      <div class="latest-project-img-container" (click)="goToPaintingDetails('2', '117')">
        <img src="../assets/gallery/117.jpg" alt="picturi favorite">
        <button mat-button  class="transparent-button">{{'seeDetails' | translate}}</button>
      </div>
      <div class="latest-project-img-container" (click)="goToPaintingDetails('1', '193')">
        <img src="../assets/gallery/193.jpg" alt="picturi favorite">
        <button mat-button  class="transparent-button">{{'seeDetails' | translate}}</button>
      </div>
      <div class="latest-project-img-container hide-mobile" (click)="goToPaintingDetails('1', '188')">
        <img src="../assets/gallery/188.jpg" alt="picturi favorite">
        <button mat-button  class="transparent-button">{{'seeDetails' | translate}}</button>
      </div>
      <div class="latest-project-img-container" (click)="goToPaintingDetails('2', '126')">
        <img src="../assets/gallery/126.jpg" alt="picturi favorite">
        <button mat-button  class="transparent-button">{{'seeDetails' | translate}}</button>
      </div>
      <div class="latest-project-img-container hide-mobile" (click)="goToPaintingDetails('1', '197')">
        <img src="../assets/gallery/197.jpg" alt="picturi favorite">
        <button mat-button  class="transparent-button">{{'seeDetails' | translate}}</button>
      </div>

    </div>

  </div>

  <div class="text-container lazy-load hidden center-margin beige-container" #lazyElement>
    <h1>
      {{'whoAmI' | translate}}
    </h1>
    <p>
      {{'aboutP1' | translate}}
      {{'aboutP2' | translate}}
      {{'aboutP3' | translate}}
      {{'aboutP4' | translate}}
      {{'aboutP5' | translate}}
    </p>
  </div>
  <div class="text-container lazy-load hidden center-margin beige-container" #lazyElement style="padding-bottom: 170px">
    <h1>
      {{'exhibitionh1' | translate}}
    </h1>
    <p>
      {{'exhibitionp1' | translate}}
      {{'exhibitionp2' | translate}}
      {{'exhibitionp3' | translate}}
      {{'exhibitionp4' | translate}}
      {{'exhibitionp5' | translate}}
      {{'exhibitionp6' | translate}}
      {{'exhibitionp7' | translate}}
      {{'exhibitionp8' | translate}}
    </p>
    <div class="curve-line-divider">
      <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z" class="shape-fill"></path>
      </svg>
    </div>
  </div>

  <div class="text-container lazy-load hidden center-margin" #lazyElement>
    <h1>{{'marketHomeh1' | translate}}</h1>
    <p>
      {{'marketHomep2' | translate}}
    </p>

    <button mat-raised-button class="simple-button" (click)="redirectToMarketplaceLogin()">{{'register' | translate}}</button>
    <div class="counters last">
      <div class="users">
        <div class="number">12</div>
        <div class="description">{{'happyUsers' | translate}}</div>
      </div>
      <div class="artists">
        <div class="number">11</div>
        <div class="description">{{'talentedArtists' | translate}}</div>
      </div>
      <div class="art-objects">
        <div class="number">39</div>
        <div class="description">{{'nrArtObjects' | translate}}</div>
      </div>
      <div class="other">
        <div class="number">5</div>
        <div class="description">{{'nrArtisticCategories' | translate}}</div>
      </div>
    </div>
  </div>
  </div>
